/**
 * Ray's Loyalty VIP banner — tier path window + split carousel
 * (banner crossfade, grade horizontal slide).
 */
(function () {
  'use strict';

  var VISIBLE_PERCENTS = [0.175, 0.5, 0.825];
  var ARC_VIEW_W = 1200;
  var ARC_VIEW_H = 62;
  var SLIDE_MS = 300;

  var TIER_DEFS_BY_HANDLE = {
    'blovo-fans': { minSpendCents: 0, minOrders12m: 0, sort: 0 },
    'bronze-queen': { minSpendCents: 0, minOrders12m: 1, sort: 1 },
    'silver-queen': { minSpendCents: 0, minOrders12m: 2, sort: 2 },
    'gold-queen': { minSpendCents: 40000, minOrders12m: 3, sort: 3 },
    'mocha-queen': { minSpendCents: 100000, minOrders12m: 6, sort: 4 },
  };

  function waitForRaysLoyalty(apiMethod, maxMs) {
    maxMs = maxMs != null ? maxMs : 8000;
    var started = Date.now();
    return new Promise(function (resolve, reject) {
      function ready() {
        return window.RaysLoyalty && typeof window.RaysLoyalty[apiMethod] === 'function';
      }
      function tick() {
        if (ready()) {
          resolve();
          return;
        }
        if (Date.now() - started > maxMs) {
          reject(new Error('rays_loyalty_sdk_timeout'));
          return;
        }
        setTimeout(tick, 40);
      }
      if (ready()) resolve();
      else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function onDcl() {
          document.removeEventListener('DOMContentLoaded', onDcl);
          if (ready()) resolve();
          else tick();
        });
      } else tick();
    });
  }

  /**
   * Theme strings from `{{ '...' | t | json }}` can contain HTML entities (e.g. &#39;) as literals.
   */
  function decodeHtmlEntities(s) {
    if (s == null || typeof s !== 'string') return s;
    if (s.indexOf('&') === -1) return s;
    try {
      var ta = document.createElement('textarea');
      ta.innerHTML = s;
      return ta.value;
    } catch (e) {
      return s;
    }
  }

  function decodeVipConfigStrings(cfg) {
    if (!cfg || typeof cfg !== 'object') return;
    if (cfg.copy && typeof cfg.copy === 'object') {
      Object.keys(cfg.copy).forEach(function (k) {
        if (typeof cfg.copy[k] === 'string') cfg.copy[k] = decodeHtmlEntities(cfg.copy[k]);
      });
    }
    ['tErr', 'tProg', 'tNext'].forEach(function (k) {
      if (typeof cfg[k] === 'string') cfg[k] = decodeHtmlEntities(cfg[k]);
    });
  }

  function getPathPoint(progression, percent) {
    if (!progression) return null;
    var path = progression.querySelector('[data-vip-arc-path]');
    var svg = progression.querySelector('.rays-loyalty-vip-banner__progression-svg');
    if (!path || typeof path.getTotalLength !== 'function' || !svg) return null;

    var pt = path.getPointAtLength(path.getTotalLength() * percent);
    var bbox = svg.getBoundingClientRect();
    var scaleX = bbox.width / ARC_VIEW_W;
    var scaleY = bbox.height / ARC_VIEW_H;
    return { x: pt.x * scaleX, y: pt.y * scaleY };
  }

  function updatePathMarkers(progression, markers, centerIndex) {
    if (!progression || !markers.length) return;

    markers.forEach(function (marker) {
      var index = parseInt(marker.getAttribute('data-idx'), 10);
      if (isNaN(index)) return;

      var relative = index - centerIndex;
      var dot = marker.querySelector('.rays-loyalty-vip-banner__tier-marker-dot');
      var glow = marker.querySelector('.rays-loyalty-vip-banner__tier-marker-glow');
      var label = marker.querySelector('.rays-loyalty-vip-banner__tier-marker-label');

      function setActive(on) {
        marker.classList.toggle('is-center', on);
        marker.classList.toggle('is-active', on);
        if (dot) dot.classList.toggle('is-active', on);
        if (glow) glow.classList.toggle('is-active', on);
        if (label) label.classList.toggle('is-active', on);
        marker.setAttribute('aria-selected', on ? 'true' : 'false');
      }

      function placeAt(percent) {
        var point = getPathPoint(progression, percent);
        if (!point) return;
        marker.style.left = point.x + 'px';
        marker.style.top = point.y + 'px';
      }

      if (relative >= -1 && relative <= 1) {
        placeAt(VISIBLE_PERCENTS[relative + 1]);
        marker.classList.remove('is-hidden');
        setActive(relative === 0);
      } else if (relative === -2) {
        placeAt(0);
        marker.classList.add('is-hidden');
        setActive(false);
      } else if (relative === 2) {
        placeAt(1);
        marker.classList.add('is-hidden');
        setActive(false);
      } else {
        marker.classList.add('is-hidden');
        setActive(false);
      }
    });
  }

  function initClubBanner(root) {
    if (!root || root.dataset.rlVipClubInit === '1') return;
    root.dataset.rlVipClubInit = '1';

    var configEl = document.getElementById('rl-vip-config-' + root.getAttribute('data-section-id'));
    var config = {};
    if (configEl && configEl.textContent) {
      try {
        config = JSON.parse(configEl.textContent);
        decodeVipConfigStrings(config);
      } catch (e) {
        config = {};
      }
    }

    var copy = config.copy || {};
    var handles = config.handles || [];
    var tiers =
      Array.isArray(config.tiers) && config.tiers.length
        ? config.tiers
        : handles.map(function (h, i) {
            var d = TIER_DEFS_BY_HANDLE[h] || { minSpendCents: 0, minOrders12m: 0, sort: i };
            return {
              handle: h,
              title: h,
              minSpendCents: d.minSpendCents,
              minOrders12m: d.minOrders12m,
              sort: d.sort != null ? d.sort : i,
            };
          });
    var tErr = config.tErr || 'Something went wrong.';

    var loadingEl = root.querySelector('[data-vip-loading]');
    var progression = root.querySelector('[data-vip-progression]');
    var gradeCarousel = root.querySelector('[data-vip-grade-carousel]');
    var gradeTrack = root.querySelector('[data-vip-grade-track]');
    var bannerLayers = root.querySelectorAll('[data-vip-banner-layer]');
    var rewardsLayers = root.querySelectorAll('[data-vip-rewards-layer]');
    var gradeSlides = root.querySelectorAll('[data-vip-grade-slide]');
    var markers = progression ? progression.querySelectorAll('[data-tier-marker]') : [];
    var btnPrev = root.querySelector('[data-vip-slider-prev]');
    var btnNext = root.querySelector('[data-vip-slider-next]');
    var slideHero = root.querySelector('[data-vip-slide-hero]');
    var popup = document.getElementById('rl-vip-popup-' + root.getAttribute('data-section-id'));

    var slideCount = gradeSlides.length;
    var currentIdx = 0;
    var matchedTierIdx = -1;
    var tierData = null;

    function setLoading(show) {
      if (loadingEl) loadingEl.hidden = !show;
      root.classList.toggle('is-loading', !!show);
    }

    function updateGradeTransform() {
      if (!gradeTrack || !gradeCarousel) return;
      var w = gradeCarousel.getBoundingClientRect().width;
      gradeTrack.style.transform = 'translate3d(' + -currentIdx * w + 'px, 0, 0)';
    }

    function layerIdx(node) {
      var n = parseInt(node.getAttribute('data-idx'), 10);
      return isNaN(n) ? -1 : n;
    }

    function setActiveLayers(nodes, idx) {
      var hasMatch = false;
      nodes.forEach(function (node) {
        var on = layerIdx(node) === idx;
        if (on) hasMatch = true;
        node.classList.toggle('is-active', on);
        node.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      return hasMatch;
    }

    function updateNavVisibility() {
      var last = slideCount - 1;
      if (btnPrev) btnPrev.hidden = currentIdx <= 0;
      if (btnNext) btnNext.hidden = currentIdx >= last;
    }

    function syncPathMarkers() {
      updatePathMarkers(progression, markers, currentIdx);
    }

    function goTo(idx) {
      if (!slideCount) return;
      var i = Math.max(0, Math.min(slideCount - 1, parseInt(idx, 10) || 0));
      if (i === currentIdx) return;
      currentIdx = i;

      setActiveLayers(bannerLayers, i);
      if (rewardsLayers.length) setActiveLayers(rewardsLayers, i);

      gradeSlides.forEach(function (slide) {
        var on = layerIdx(slide) === i;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      if (gradeTrack) {
        gradeTrack.style.transition = 'transform ' + SLIDE_MS + 'ms ease';
        updateGradeTransform();
      }

      syncPathMarkers();
      updateNavVisibility();
      if (tierData) applyTierData(tierData, matchedTierIdx);
    }

    function resolvePointsBalance(data) {
      if (!data || typeof data !== 'object') return null;
      var keys = ['pointsBalance', 'points_balance', 'balance', 'points'];
      for (var i = 0; i < keys.length; i++) {
        var v = data[keys[i]];
        if (v != null && v !== '') {
          var n = Number(v);
          return isNaN(n) ? String(v) : n;
        }
      }
      if (data.tier && typeof data.tier === 'object') {
        return resolvePointsBalance(data.tier);
      }
      if (data.customer && typeof data.customer === 'object') {
        return resolvePointsBalance(data.customer);
      }
      return null;
    }

    function readLiquidPoints() {
      var fromRoot = root.getAttribute('data-rl-vip-liquid-points');
      if (fromRoot != null && String(fromRoot).trim() !== '') {
        var p = Number(fromRoot);
        return isNaN(p) ? String(fromRoot).trim() : p;
      }
      if (config.liquidPoints != null && config.liquidPoints !== '') {
        var c = Number(config.liquidPoints);
        return isNaN(c) ? config.liquidPoints : c;
      }
      return null;
    }

    function formatPointsBalance(balance) {
      if (balance == null) return '0';
      if (typeof balance === 'number' && isFinite(balance)) {
        try {
          return balance.toLocaleString();
        } catch (e) {
          return String(balance);
        }
      }
      return String(balance);
    }

    function setElText(el, text) {
      if (!el) return;
      el.textContent = text != null ? String(text) : '';
    }

    function getRollingStats(data) {
      if (!data || typeof data !== 'object') {
        return { spendCents: 0, orderCount: 0 };
      }
      return {
        spendCents: Number(data.rolling12mSpendCents || data.rolling12m_spend_cents || 0) || 0,
        orderCount: Number(data.rolling12mOrderCount || data.rolling12m_order_count || 0) || 0,
      };
    }

    function formatMoneyCents(cents) {
      var n = Math.max(0, Math.round(Number(cents) || 0)) / 100;
      var whole = Math.floor(n);
      var frac = Math.round((n - whole) * 100);
      if (frac === 0) {
        try {
          return '$' + whole.toLocaleString();
        } catch (e) {
          return '$' + whole;
        }
      }
      var fracStr = frac < 10 ? '0' + frac : String(frac);
      try {
        return '$' + whole.toLocaleString() + '.' + fracStr;
      } catch (e2) {
        return '$' + whole + '.' + fracStr;
      }
    }

    function mergeTierDef(tierLike) {
      if (!tierLike) return null;
      var h = tierLike.handle;
      var i;
      for (i = 0; i < tiers.length; i++) {
        if (tiers[i].handle === h) {
          return {
            handle: h,
            title: tierLike.title || tiers[i].title || h,
            minSpendCents:
              tierLike.minSpendCents != null ? Number(tierLike.minSpendCents) : tiers[i].minSpendCents,
            minOrders12m:
              tierLike.minOrders12m != null ? Number(tierLike.minOrders12m) : tiers[i].minOrders12m,
          };
        }
      }
      var fb = TIER_DEFS_BY_HANDLE[h] || { minSpendCents: 0, minOrders12m: 0 };
      return {
        handle: h,
        title: tierLike.title || h,
        minSpendCents: tierLike.minSpendCents != null ? Number(tierLike.minSpendCents) : fb.minSpendCents,
        minOrders12m: tierLike.minOrders12m != null ? Number(tierLike.minOrders12m) : fb.minOrders12m,
      };
    }

    function tierAtIndex(idx) {
      if (idx < 0 || idx >= tiers.length) return null;
      return tiers[idx];
    }

    function buildScheduleText(stats, target) {
      if (!target) return '';
      var parts = [];
      if (target.minSpendCents > 0) {
        parts.push(formatMoneyCents(stats.spendCents) + '/' + formatMoneyCents(target.minSpendCents));
      }
      if (target.minOrders12m > 0) {
        parts.push(stats.orderCount + '/' + target.minOrders12m + ' Orders');
      }
      return parts.join(' & ');
    }

    function progressTowardTier(stats, target) {
      if (!target) return 0;
      var spendR =
        target.minSpendCents > 0 ? Math.min(1, stats.spendCents / target.minSpendCents) : 1;
      var orderR =
        target.minOrders12m > 0 ? Math.min(1, stats.orderCount / target.minOrders12m) : 1;
      return Math.min(spendR, orderR);
    }

    function setBar(pw, pr, pct) {
      if (!pw || !pr) return;
      pw.style.display = '';
      var p = Math.round(Math.min(1, Math.max(0, pct)) * 100);
      pr.style.width = p + '%';
    }

    function updatePointsRows(balance) {
      var rows = root.querySelectorAll('[data-vip-points-balance], [data-points-row]');
      if (!rows.length) return;
      var text = formatPointsBalance(balance != null ? balance : 0);
      rows.forEach(function (row) {
        row.hidden = false;
        row.removeAttribute('hidden');
        row.style.display = 'inline-flex';
        row.classList.add('is-ready');
        var val = row.querySelector('[data-vip-points-value]');
        if (val) val.textContent = text;
      });
    }

    function applyTierData(data, mIdx) {
      if (!data) return;
      tierData = data;
      var stats = getRollingStats(data);
      var nextTier = data.next ? mergeTierDef(data.next) : tierAtIndex(mIdx + 1);
      var bal = resolvePointsBalance(data);
      if (bal == null && window.RaysLoyalty && typeof window.RaysLoyalty.getRewards === 'function') {
        window.RaysLoyalty.getRewards()
          .then(function (rewardsRes) {
            var rb = resolvePointsBalance(rewardsRes);
            updatePointsRows(rb != null ? rb : 0);
          })
          .catch(function () {
            updatePointsRows(0);
          });
      } else {
        updatePointsRows(bal != null ? bal : 0);
      }

      gradeSlides.forEach(function (slide) {
        var idx = parseInt(slide.getAttribute('data-idx'), 10);
        if (isNaN(idx)) return;

        var badge = slide.querySelector('[data-tier-badge]');
        var gradeTime = slide.querySelector('[data-vip-grade-time]');
        var gradeTierLabel = slide.querySelector('[data-vip-grade-tier-label]');
        var pr = slide.querySelector('[data-vip-progress-fill]');
        var pw = slide.querySelector('[data-vip-progress-wrap]');
        var pl = slide.querySelector('[data-vip-progress-label]');
        var slideTier = tierAtIndex(idx);
        var rel = 'current';

        if (mIdx >= 0) {
          if (idx < mIdx) rel = 'past';
          else if (idx > mIdx) rel = 'future';
          else rel = 'current';
        } else {
          rel = idx === 0 ? 'current' : 'future';
        }

        if (badge) {
          badge.classList.remove('is-past', 'is-future', 'is-current');
          badge.removeAttribute('data-tier-rel');
          if (rel === 'past') {
            badge.textContent = copy.past || '';
            badge.classList.add('is-past');
            badge.setAttribute('data-tier-rel', 'past');
          } else if (rel === 'future') {
            badge.textContent = copy.other || '';
            badge.classList.add('is-future');
            badge.setAttribute('data-tier-rel', 'future');
          } else {
            badge.textContent = copy.current || '';
            badge.classList.add('is-current');
            badge.setAttribute('data-tier-rel', 'current');
          }
        }

        setElText(gradeTime, '');
        setElText(gradeTierLabel, '');

        if (rel === 'past') {
          setBar(pw, pr, 1);
          setElText(pl, copy.unlocked || '');
        } else if (rel === 'future') {
          setElText(gradeTime, copy.notReached || '');
          setElText(gradeTierLabel, copy.reachThis || '');
          var targetFuture = slideTier || { minSpendCents: 0, minOrders12m: 0 };
          var schedFuture = buildScheduleText(stats, targetFuture);
          setBar(pw, pr, progressTowardTier(stats, targetFuture));
          if (schedFuture) {
            setElText(pl, schedFuture);
          } else {
            var uhint = slide.getAttribute('data-unlock-hint');
            setElText(
              pl,
              uhint && String(uhint).trim()
                ? String(uhint).trim()
                : copy.tierUnlockFallback || copy.locked || ''
            );
          }
        } else if (pw && pr && pl) {
          if (nextTier) {
            var schedNext = buildScheduleText(stats, nextTier);
            var barPct =
              typeof data.progress === 'number'
                ? data.progress
                : progressTowardTier(stats, nextTier);
            setBar(pw, pr, barPct);
            setElText(gradeTierLabel, copy.reachNext || '');
            setElText(pl, schedNext || copy.tierUnlockFallback || '');
          } else if (data.tier) {
            setBar(pw, pr, 1);
            setElText(pl, copy.top || '');
          } else {
            if (pw) pw.style.display = 'none';
            setElText(pl, '');
          }
        }
      });
    }

    function onLayout() {
      updateGradeTransform();
      syncPathMarkers();
    }

    if (gradeTrack) {
      gradeTrack.style.transition = 'none';
      updateGradeTransform();
      requestAnimationFrame(function () {
        if (gradeTrack) gradeTrack.style.transition = '';
      });
    }
    syncPathMarkers();
    updateNavVisibility();
    window.addEventListener('resize', onLayout);

    markers.forEach(function (m) {
      m.addEventListener('click', function () {
        var index = parseInt(m.getAttribute('data-idx'), 10);
        if (isNaN(index) || m.classList.contains('is-hidden')) return;
        if (Math.abs(index - currentIdx) !== 1) return;
        goTo(index);
      });
    });

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        goTo(currentIdx - 1);
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        goTo(currentIdx + 1);
      });
    }

    function initTouchSwipe(el) {
      if (!el || slideCount < 2) return;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var SWIPE_MIN = 44;
      var MAX_VERTICAL = 72;

      el.addEventListener(
        'touchstart',
        function (ev) {
          if (!ev.touches || ev.touches.length !== 1) return;
          startX = ev.touches[0].clientX;
          startY = ev.touches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      el.addEventListener(
        'touchend',
        function (ev) {
          if (!tracking) return;
          tracking = false;
          var touch = ev.changedTouches && ev.changedTouches[0];
          if (!touch) return;
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dy) > MAX_VERTICAL && Math.abs(dy) > Math.abs(dx)) return;
          if (dx <= -SWIPE_MIN) goTo(currentIdx + 1);
          else if (dx >= SWIPE_MIN) goTo(currentIdx - 1);
        },
        { passive: true }
      );
    }

    initTouchSwipe(slideHero || gradeCarousel);

    if (popup) {
      var titleEl = popup.querySelector('[data-popup-title]');
      var bodyEl = popup.querySelector('[data-popup-body]');
      function closePop() {
        popup.hidden = true;
        document.body.classList.remove('rl-vip-popup-open');
      }
      popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
        el.addEventListener('click', closePop);
      });
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-reward-tip]');
        if (!btn) return;
        e.preventDefault();
        if (titleEl) titleEl.textContent = btn.getAttribute('data-reward-title') || '';
        if (bodyEl) bodyEl.textContent = btn.getAttribute('data-reward-tip') || '';
        popup.hidden = false;
        document.body.classList.add('rl-vip-popup-open');
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !popup.hidden) closePop();
      });
    }

    function showError() {
      setLoading(false);
      var err = document.createElement('p');
      err.className = 'rays-loyalty__error rays-loyalty-vip-banner__error';
      err.textContent = tErr;
      root.appendChild(err);
    }

    var liquidPts = readLiquidPoints();
    if (liquidPts != null) updatePointsRows(liquidPts);

    setLoading(true);

    waitForRaysLoyalty('getTier')
      .then(function () {
        if (window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {
          try {
            window.RaysLoyalty.syncStorefrontTokenFromWebComponents();
          } catch (e) {}
        }
        return window.RaysLoyalty.getTier();
      })
      .then(function (data) {
        setLoading(false);
        var h = data && data.tier && data.tier.handle;
        var idxFound = -1;
        if (h) {
          handles.forEach(function (th, i) {
            if (th && h === th) idxFound = i;
          });
        }
        matchedTierIdx = idxFound;
        currentIdx = idxFound >= 0 ? idxFound : 0;

        setActiveLayers(bannerLayers, currentIdx);
        if (rewardsLayers.length) setActiveLayers(rewardsLayers, currentIdx);
        gradeSlides.forEach(function (slide) {
          var on = layerIdx(slide) === currentIdx;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        });

        onLayout();
        updateNavVisibility();
        applyTierData(data, idxFound);
      })
      .catch(function () {
        showError();
      });
  }

  function refreshAllVipBannerPoints() {
    if (!window.RaysLoyalty || typeof window.RaysLoyalty.getRewards !== 'function') {
      return;
    }
    window.RaysLoyalty.getRewards()
      .then(function (data) {
        var bal =
          data && typeof data.pointsBalance === 'number' ? data.pointsBalance : 0;
        var text;
        try {
          text = bal.toLocaleString();
        } catch (e) {
          text = String(bal);
        }
        document.querySelectorAll('[data-vip-points-value]').forEach(function (el) {
          el.textContent = text;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('rays-loyalty:redeemed', refreshAllVipBannerPoints);

  function boot() {
    document.querySelectorAll('[data-rl-vip-club]').forEach(initClubBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
